export const BANNER_TITLE_TEST_ID = {
  title: 'partner-banner-title',
};
